import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { ProyectosComponent } from './proyectos/proyectos.component';
import { TareasComponent } from './tareas/tareas.component';
import { CatalogosComponent } from './catalogos/catalogos.component';
import { RolesComponent } from './roles/roles.component';
import { GestoresComponent } from './gestores/gestores.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { PerfilComponent } from './perfil/perfil.component';
import { BuscadorComponent } from './buscador/buscador.component';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'proyectos', component: ProyectosComponent },
      { path: 'tareas', component: TareasComponent },
      { path: 'catalogos', component: CatalogosComponent },
      { path: 'roles', component: RolesComponent },
      { path: 'gestores', component: GestoresComponent },
      { path: 'usuarios', component: UsuariosComponent },
      { path: 'perfil', component: PerfilComponent },
    ],
  },
  { path: 'buscador', component: BuscadorComponent, canActivate: [authGuard] },
];
